import styled from 'styled-components';
import BestClassSvg from '../../../assets/onboarding/newHome/best-class.svg';

const BestClassIcon = styled(BestClassSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.2rem'};
height: ${props => props.height || '4.2rem'};
display: flex;
`;

export default BestClassIcon;
